import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, FileText, Scale } from 'lucide-react';

const Services = () => {
  const services = [
    {
      title: 'Incorporation Services',
      description: 'Comprehensive business formation and registration services. We guide you through entity selection, compliance, and documentation.',
      image: 'https://images.unsplash.com/photo-1758599543152-a73184816eba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMHByb2Zlc3Npb25hbCUyMG1lZXRpbmd8ZW58MHx8fHwxNzcxNTAxNTU0fDA&ixlib=rb-4.1.0&q=85',
      icon: Building2
    },
    {
      title: 'Export/Import Documentation',
      description: 'Expert assistance with international trade documentation, customs compliance, and regulatory requirements for seamless global operations.',
      image: 'https://images.unsplash.com/photo-1766678340672-51e6be3a64d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNvbnRhaW5lciUyMGFic3RyYWN0fGVufDB8fHx8MTc3MTUwMTU1NXww&ixlib=rb-4.1.0&q=85',
      icon: FileText
    },
    {
      title: 'Intellectual Property Law',
      description: 'Protect your innovations with comprehensive IP services including patents, trademarks, copyrights, and licensing agreements.',
      image: 'https://images.unsplash.com/photo-1751802037144-d4a6f39cab06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxpbnRlbGxlY3R1YWwlMjBwcm9wZXJ0eSUyMGJsdWVwcmludCUyMGFic3RyYWN0fGVufDB8fHx8MTc3MTUwMTU1OHww&ixlib=rb-4.1.0&q=85',
      icon: Scale
    }
  ];

  return (
    <section id="services" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <p className="text-yellow-500 uppercase tracking-widest text-sm font-semibold mb-4">
            Our Services
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Comprehensive Legal Support
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card 
                key={index} 
                className="bg-slate-800/50 border-slate-700 overflow-hidden group hover:border-yellow-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-yellow-500/10 hover:-translate-y-2 animate-slide-up"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 bg-yellow-500 p-3 rounded-lg transition-transform duration-300 group-hover:scale-110">
                    <Icon className="h-6 w-6 text-slate-900" />
                  </div>
                </div>
                <CardContent className="p-6 space-y-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-yellow-500 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;